module.exports = __webpack_public_path__ + "img/wallet-interest.cdf7e80c.svg";